import { BaseTable, Button, Modal } from 'components'
import { EmployeePreviewType } from '../types'
import moment from 'moment'

type ModalPreviewType = {
  data: EmployeePreviewType[]
  show: boolean
  handleCloseModal: () => void
  handleSubmitModal: () => void
}

export const ModalPreview = ({ data, show, handleCloseModal, handleSubmitModal }: ModalPreviewType) => {
  const borderTH = "border-2 border-[#A6AEBF]"

  return (
    <div>
      {show && (
        <Modal isOpen title="DATA FORM EXCEL" closeModal={handleCloseModal}>
          <Modal.Body>
            <div className="overflow-x-auto">
              <BaseTable>
                <thead className='bg-[#EEEEEE]'>
                  <tr>
                    <th className={borderTH}>NO</th>
                    <th className={borderTH}>FULL NAME</th>
                    <th className={borderTH}>TYPE OF NATIONALITY</th>
                    <th className={borderTH}>ID NUMBER</th>
                    <th className={borderTH}>DATE OF BIRTH</th>
                    <th className={borderTH}>MARTIAL STATUS</th>
                    <th className={borderTH}>RELIGION</th>
                    <th className={borderTH}>HANDPHONE</th>
                    <th className={borderTH}>EMAIL</th>
                    <th className={borderTH}>COUNTRY</th>
                    <th className={borderTH}>PROVINCE</th>
                    <th className={borderTH}>REGENCY</th>
                    <th className={borderTH}>SUBDISTRICT</th>
                    <th className={borderTH}>VILLAGE</th>
                    <th className={borderTH}>ADDRESS</th>
                    <th className={borderTH}>DATE START</th>
                    <th className={borderTH}>MAIN LOCATION</th>
                    <th className={borderTH}>DIVISION</th>
                    <th className={borderTH}>DEPARTMENT</th>
                    <th className={borderTH}>EMPLOYMENT TITLE</th>
                    <th className={borderTH}>ROLE MANAGEMENT</th>
                    <th className={borderTH}>GENDER</th>
                    <th className={borderTH}>SALARY TYPE</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((val, index) => (
                    <tr key={index} className="hover:bg-gray-100">
                      <td className={`${borderTH} text-center`}>{index + 1}</td>
                      <td className={`${borderTH} min-w-[300px]`}>{val.FULL_NAME ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.TYPE_OF_NATIONALITY ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.ID_NUMBER ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.DATE_OF_BIRTH ? moment(val.DATE_OF_BIRTH).format('DD-MM-YYYY') : "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.MARITAL_STATUS ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.RELIGION ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.HANDPHONE ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.EMAIL ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.COUNTRY ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.PROVINCE ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.REGENCY ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.SUBDISTRICT ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.VILLAGE ?? "-"}</td>
                      <td className={`${borderTH} min-w-[150px]`}>{val.ADDRESS ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.DATE_START ? moment(val.DATE_START).format('DD-MM-YYYY') : "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.MAIN_LOCATION ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.DIVISION ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.DEPARTMENT ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.EMPLOYMENT_TITLE ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.ROLE_MANAGEMENT ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.GENDER ?? "-"}</td>
                      <td className={`${borderTH} text-nowrap`}>{val.SALARY_TYPE ?? "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </BaseTable>
            </div>

            <Noted />
          </Modal.Body>
          <Modal.Footer className="text-end">
              <div className="flex justify-end">
              <div className="flex gap-3">
                  <Button color="error" onClick={handleCloseModal}>CANCEL</Button>
                  <Button color="primary" onClick={handleSubmitModal}>OK</Button>
              </div>
              </div>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  )
}

const Noted = () => (
  <>
    <div className="mt-5"><b>NB : </b></div>
    <div>
      <b>The data comes from the excel file you sent, it has not been corrected according to Hawk standards, after saving please review it first in the upload file list</b>
    </div>
  </>
)